<template>
  <div class="f-ast f-v">
    <donut-modal-sections-title
      title="Configure fulfillment channel"
      title-svg="nucleo/slack"
      :title-image-version="1"
    />
    <p class="t-lg">{{ `Donut will send a message to this private Slack channel every time someone redeems a ${$i18n.t('shoutouts.reward', { count: 1 })} — so you can track and fulfill it.` }}</p>
    <p class="t-lg m-tx1 bold">How to set it up:</p>
    <p class="t-lg m-tx1 m-lx1">1. Go to a private Slack channel in Slack (or create one)</p>
    <p class="t-lg m-tx1 m-lx1 slack-preview">2. Invite Donut by typing <code>/invite @donut</code></p>
    <p class="t-lg m-tx1 m-lx1">3. Come back here and select the channel below:</p>
    <donut-selector-prefabs-channel
      v-model="fulfillmentChannel"
      class="m-tx2"
      :key-map="{ value: 'uid' }"
      placeholder="Search private Slack channels..."
      :only-private="true"
    />
    <donut-modal-sections-actions
      save-action="rewardsProgram/saveFulfillmentChannel"
      :save-args="{ fulfillmentChannelId: fulfillmentChannel?.id }"
      :save-tracking="{eventName: 'Rewards Program - Submitted Fulfillment Channel'}"
      :is-save-disabled="!fulfillmentChannel"
    />
  </div>
</template>

<script setup>
  import { ref, computed, inject } from 'vue';
  import { useStore } from 'vuex';

  const { state } = useStore();
  const $i18n = inject('$i18n');

  const fulfillmentChannel = ref(state.rewardsProgram.program.redemption_fulfillment_channel_id);
</script>
